import React, { useState, useEffect } from 'react';
import moment from 'moment';

import FilterWrap from 'components/atoms/FilterWrap';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

import FreqStatisticsTtimeGraph from './FreqStatisticsTtimeGraph';

let initialization = false;
let initParam = {
  sDate: moment().format('YYYYMM'),
  eDate: moment().format('YYYYMM'),
};
const FreqCrossStatistics = ({ displayFilterList, switchDatas }) => {
  // 통계보고서 - 어뷰징관리 - 전환율: adverId, eDate, isPop, popGroup, sDate, uri

  // const { t } = useTranslation();
  //const classes = useStyles();

  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);

    setParams({
      ...params,
      ...newParams,
    });
  };
  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          initData={initParam}
          displayFilterList={displayFilterList}
          noneExternalFilter
          useMonthDate
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <FreqStatisticsTtimeGraph
            switchDatas={switchDatas}
            params={{ ...params }}
          />
        </>
      )}
    </>
  );
};

export default FreqCrossStatistics;
